import {
  LIBRARY_GRATUITY_PAGE_REQUEST,
  LIBRARY_GRATUITY_SET_OUTLETS,
  LIBRARY_GRATUITY_OUTLETS_REQUEST,
  LIBRARY_GRATUITY_ON_CHANGE_OUTLET_IDS,
  LIBRARY_GRATUITY_ON_CLICK_CREATE_GRATUITY,
  LIBRARY_GRATUITY_SET_GRATUITIES,
  LIBRARY_GRATUITY_ON_CLICK_ROW,
  LIBRARY_GRATUITY_SET_GRATUITY_DETAIL,
  LIBRARY_GRATUITY_GRATUITIES_REQUEST,
  LIBRARY_GRATUITY_SET_CURRENT_PAGE,
  LIBRARY_GRATUITY_SET_TOTAL_PAGE,
  LIBRARY_GRATUITY_ON_CLICK_CANCEL,
  LIBRARY_GRATUITY_SUBMIT_FORM_CREATE,
  LIBRARY_GRATUITY_SUBMIT_FORM_UPDATE,
  LIBRARY_GRATUITY_DELETE_GRATUITY,
  LIBRARY_GRATUITY_CANCEL_DELETE_GRATUITY,
  LIBRARY_GRATUITY_SHOW_DELETE_GRATUITY_MODAL,
  LIBRARY_GRATUITY_HIDE_DELETE_GRATUITY_MODAL,
  LIBRARY_GRATUITY_SET_DELETED_GRATUITY,
  LIBRARY_GRATUITY_ASK_DELETE_GRATUITY,
  LIBRARY_GRATUITY_SUBMIT_FORM_CREATE_ALL_OUTLET,
  LIBRARY_GRATUITY_OPEN_RIGHT_COLUMN,
  LIBRARY_GRATUITY_CLOSE_RIGHT_COLUMN,
  LIBRARY_GRATUITY_IS_SUBMITTING_FORM
} from './constants'

export function pageRequest () {
  return {type: LIBRARY_GRATUITY_PAGE_REQUEST, payload: {}}
}

export function setOutlets (outlets) {
  return {type: LIBRARY_GRATUITY_SET_OUTLETS, payload: {outlets}}
}

export function outletsRequest (params) {
  return {type: LIBRARY_GRATUITY_OUTLETS_REQUEST, payload: {params}}
}

export function gratuitiesRequest (params, previousGratuities) {
  return {type: LIBRARY_GRATUITY_GRATUITIES_REQUEST, payload: {params, previousGratuities}}
}

export function onChangeOutletIds (outletIds) {
  return {type: LIBRARY_GRATUITY_ON_CHANGE_OUTLET_IDS, payload: {outletIds: outletIds}}
}

export function onClickCreateGratuity () {
  return {type: LIBRARY_GRATUITY_ON_CLICK_CREATE_GRATUITY, payload: {}}
}

export function onClickRow (gratuity) {
  return {type: LIBRARY_GRATUITY_ON_CLICK_ROW, payload: {gratuity}}
}

export function onClickCancel () {
  return {type: LIBRARY_GRATUITY_ON_CLICK_CANCEL, payload: {}}
}

export function setGratuities (gratuities) {
  return {type: LIBRARY_GRATUITY_SET_GRATUITIES, payload: {gratuities}}
}

export function setGratuityDetail (gratuity) {
  return {type: LIBRARY_GRATUITY_SET_GRATUITY_DETAIL, payload: {gratuity}}
}

export function setCurrentPage (currentPage) {
  return {type: LIBRARY_GRATUITY_SET_CURRENT_PAGE, payload: {currentPage}}
}

export function setTotalPage (totalPage) {
  return {type: LIBRARY_GRATUITY_SET_TOTAL_PAGE, payload: {totalPage}}
}

export function submitFormCreate (data, previousGratuities) {
  return {type: LIBRARY_GRATUITY_SUBMIT_FORM_CREATE, payload: {data, previousGratuities}}
}

export function submitFormCreateAllOutlet (data, previousGratuities) {
  return {type: LIBRARY_GRATUITY_SUBMIT_FORM_CREATE_ALL_OUTLET, payload: {data, previousGratuities}}
}

export function submitFormUpdate (gratuityId, data, previousGratuities) {
  return {type: LIBRARY_GRATUITY_SUBMIT_FORM_UPDATE, payload: {gratuityId, data, previousGratuities}}
}

export function deleteGratuity (gratuityId, previousGratuities) {
  return {type: LIBRARY_GRATUITY_DELETE_GRATUITY, payload: {gratuityId, previousGratuities}}
}

export function cancelDeleteGratuity () {
  return {type: LIBRARY_GRATUITY_CANCEL_DELETE_GRATUITY, payload: {}}
}

export function showDeleteGratuityModal () {
  return {type: LIBRARY_GRATUITY_SHOW_DELETE_GRATUITY_MODAL, payload: {}}
}

export function hideDeleteGratuityModal () {
  return {type: LIBRARY_GRATUITY_HIDE_DELETE_GRATUITY_MODAL, payload: {}}
}

export function setDeletedGratuity (deletedGratuity) {
  return {type: LIBRARY_GRATUITY_SET_DELETED_GRATUITY, payload: {deletedGratuity}}
}

export function askDeleteGratuity (deletedGratuity) {
  return {type: LIBRARY_GRATUITY_ASK_DELETE_GRATUITY, payload: {deletedGratuity}}
}

export function openRightColumn () {
  return {type: LIBRARY_GRATUITY_OPEN_RIGHT_COLUMN, payload: {}}
}

export function closeRightColumn () {
  return {type: LIBRARY_GRATUITY_CLOSE_RIGHT_COLUMN, payload: {}}
}

export function isSubmittingForm (isSubmittingForm) {
  return {type: LIBRARY_GRATUITY_IS_SUBMITTING_FORM, payload: {isSubmittingForm}}
}



// WEBPACK FOOTER //
// ./app/actions/library/gratuity/gratuity.js